export const DM_Press = {
    Pmin: 0,    // Минимальное давление (4 мА = 0 Бар)
    minADC: 710, // Минимальное значение АЦП (соответствует 4 мА) - 689
    maxADC: 3290, // Максимальное значение АЦП (соответствует 20 мА) - 3150/3470
}
// АЦП~800 -минимум 4мА или 0 Бар. АЦП~3000-максимум 20мА или Pmax(предел датчика) 
// P=Pmin+(Pmax-Pmin)*(АЦП-minАЦП/maxАЦП-minАЦП)